import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export type Product = {
    id: number;
    name: string;
    mpn: string;
    description: string;
    brand_id: number;
    overridden_at: string;
    has_image: boolean;
    verified: boolean;
    updated_at: string;
    created_at: string;
    brand: {
        id: number;
        name: string;
        name_key: string;
        overridden_at: string;
        updated_at: string;
        created_at: string;
    };
    vendor_products: VendorProduct[];
    isTruncated: boolean;
};

export type VendorProduct = {
    id: number;
    product_id: number;
    vendor_id: number;
    last_price: number;
    crawled_at: string;
    is_available: boolean | null;
    sku: string;
    description?: string;
    buy_url: string;
    img_url: any;
    name: string;
    overridden_at: any;
    height: any;
    width: any;
    length: any;
    weight: any;
    lead_time_days: any;
    price_unit_of_measure?: number;
    updated_at: string;
    created_at: string;
    vendors: {
        id: number;
        name: string;
        domain: string;
        updated_at: any;
        created_at: string;
    };
    vendor_product_prices: {
        price: number;
        created_at: string;
        in_stock: boolean;
    }[];
};

export type ProductSearchResults = {
    data: {
        productSearchId: string;
        productSearchResults: [
            {
                score: string;
                product: {
                    brand: string;
                    description: string;
                    id: string;
                    lowestPrice: number;
                    mpn: string;
                    name: string;
                    vendorCount: number;
                };
            },
        ];
    };
    pagination: {
        totalPages: number;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        currentPage: number;
        total: number;
    };
};

export default {
    getPricedProduct: async (brand: string, mpn: string): Promise<Product | null> => {
        try {
            const res = await fetch(`${PURCHASER_API_BASE_URL}/products/${encodeURIComponent(brand)}/${encodeURIComponent(mpn)}`, {
                headers: getHeaders(),
            });
            return res.status === 200 ? res.json() : null;
        } catch (err) {
            console.error(err);
            return null;
        }
    },

    revealProduct: async (brand: string, mpn: string): Promise<null> => {
        const res = await fetch(`${PURCHASER_API_BASE_URL}/products/reveal`, {
            headers: getHeaders(),
            body: JSON.stringify({ brand, mpn }),
            method: "POST",
        });
        return res.status === 200 ? res.json() : null;
    },

    performProductSearch: async (query: string, limit = 100, offset = 0): Promise<ProductSearchResults> => {
        return fetch(`${PURCHASER_API_BASE_URL}/products/search`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ q: query || "", limit, offset, productSearchId: undefined }),
        })
            .then(res => (res.status === 200 ? res.json() : null))
            .catch(err => console.error(err));
    },
};
